export interface ResolveTenantOptions {
  readonly hostname: string;
  readonly devOverride?: string;
  readonly rootDomain?: string;
}

const TENANT_SLUG = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export function isTenantSlug(value: string): boolean {
  return TENANT_SLUG.test(value);
}

/** Resolves only the tenant slug; it never changes API transport headers. */
export function resolveTenantSlug({
  hostname,
  devOverride,
  rootDomain = "nasam.net",
}: ResolveTenantOptions): string | null {
  const override = devOverride?.trim().toLowerCase();
  if (override !== undefined && override.length > 0) {
    if (!isTenantSlug(override)) {
      throw new Error(`Invalid VITE_DEV_TENANT value "${devOverride}".`);
    }
    return override;
  }

  const normalised = hostname.trim().toLowerCase().replace(/\.$/, "");
  if (normalised.endsWith(".localhost")) {
    const slug = normalised.slice(0, -".localhost".length);
    return isTenantSlug(slug) ? slug : null;
  }

  const suffix = `.${rootDomain.toLowerCase()}`;
  if (!normalised.endsWith(suffix)) return null;

  const slug = normalised.slice(0, -suffix.length);
  return isTenantSlug(slug) && slug !== "www" ? slug : null;
}
